let learningResourcesGroups = document.querySelectorAll('.assets-reveal');
  if (learningResourcesGroups) {
    learningResourcesGroups.forEach(function(learningResourcesGroup) {
      let label = learningResourcesGroup.previousElementSibling,
          assets  = learningResourcesGroup.children,
          assetsTotal = assets.length;
      label.setAttribute('data-assets', '(' + assetsTotal + ' PDFs)' )
  });
}